var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"post-search-header"},[_c('span',{staticClass:"post-search-header__title"},[_vm._v(" Поиск постов по ключевым словам ")])])
}]

export { render, staticRenderFns }